module.exports = __webpack_public_path__ + "static/media/IMG_1405.1d39a5f2.JPG";